import { Action } from 'redux';

import { SetDescription } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../models/IContentInfo';

export interface SetDescriptionAction extends Action {
  item: IContentInfo<'database'> | IContentInfo<'table'> | IContentInfo<'virtualConnection'> | IContentInfo<'virtualConnectionTable'>;
}

export function setDescriptionAction(item: IContentInfo<'database'> | IContentInfo<'table'> | IContentInfo<'virtualConnection'> | IContentInfo<'virtualConnectionTable'>): SetDescriptionAction {
  return {
    type: SetDescription,
    item
  };
}
